import { render, staticRenderFns } from "./SecurityManagementTableBase.vue?vue&type=template&id=6cd6d8b0&scoped=true"
import script from "./SecurityManagementTableBase.vue?vue&type=script&lang=js"
export * from "./SecurityManagementTableBase.vue?vue&type=script&lang=js"
import style0 from "./SecurityManagementTableBase.vue?vue&type=style&index=0&id=6cd6d8b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6d8b0",
  null
  
)

export default component.exports